import React from "react";
import { Breadcrumb, Button, Space, Tag, Typography } from "antd";
import {
    CalendarOutlined,
    MoreOutlined,
    NumberOutlined,
    ShareAltOutlined,
    StarOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { WbSubject } from "../../workbench/types/WbTypes";
import WorkbenchNewEntityTypeTag from "./WorkbenchNewEntityTypeTag";

const { Title } = Typography;

type Props = {
    broker: string;
    identifier: string;
    onFollow: (event: React.MouseEvent<HTMLElement>) => void;
    onMore: (event: React.MouseEvent<HTMLElement>) => void;
    onShare: () => void;
    statusLabel: string;
    subject?: WbSubject | null;
    title: string;
    uwYear: number | string;
};

const WorkbenchNewSubjectHeader: React.FC<Props> = ({
    broker,
    identifier,
    onFollow,
    onMore,
    onShare,
    statusLabel,
    subject,
    title,
    uwYear,
}) => (
    <div className="workbench-new-subject-header">
        <div>
            <Breadcrumb
                items={[
                    {
                        title: <Link to="/workbench-new">Search results</Link>,
                    },
                    { title },
                ]}
            />
            <div className="workbench-new-subject-title-row">
                <Title level={1}>{title}</Title>
                <WorkbenchNewEntityTypeTag kind={subject?.kind ?? "Contract"} />
                <Tag>{statusLabel}</Tag>
            </div>
            <Space
                className="workbench-new-subject-meta"
                wrap={true}
                size={[18, 8]}
            >
                <span>
                    <span
                        aria-hidden="true"
                        className="workbench-new-subject-company-icon"
                    />
                    {broker}
                </span>
                <span>
                    <CalendarOutlined />
                    UW Year {uwYear}
                </span>
                <span>
                    <NumberOutlined />
                    Submission ID: {identifier}
                </span>
            </Space>
        </div>
        <Space className="workbench-new-subject-actions">
            <Button icon={<ShareAltOutlined />} onClick={onShare}>
                Share
            </Button>
            <Button icon={<StarOutlined />} onClick={onFollow}>
                Follow
            </Button>
            <Button
                aria-label="More actions"
                icon={<MoreOutlined />}
                onClick={onMore}
            />
        </Space>
    </div>
);

export default WorkbenchNewSubjectHeader;
